import { Subtitle, Text, bre } from "mondrian-react";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
const Wrapper = styled.div`
  margin-top: 24px;
  max-width: 600px;
  .mdn-ShortcutGroup {
    display: inline-flex;
    flex: 1;
    flex-direction: row;
    align-items: unset;
    flex-wrap: wrap;
    .mdn-Shortcut {
      margin-bottom: 16px;
      margin-right: 16px;
    }
    img {
      align-self: flex-start;
      max-height: 50px;
      max-width: 85px;
    }
  }
  .cred-ShortcutList-title {
    margin-bottom: 16px;
  }
  .mdn-Shortcut-text-description {
    line-height: 15px;
  }
  
`;
export default function ShortcutListLinks({ ...props }) {
  if (!props.links) return null;

  return (
    <Wrapper>
      <Text className="cred-ShortcutList-title">Você também pode acessar:</Text>
      <div className="mdn-ShortcutGroup">
        {props.links.map(
          ({ title, description, href, target = "_self", logo }, index) => (
            <>
              <a
                key={`shortcut-${index}`}
                class="mdn-Shortcut mdn-Shortcut--secondary"
                target={target}
                href={href}
                title={`Ir para ${title}`}
                tabIndex={!props.firstTab ? -1 : 30 + index}
              >
                <img class="" src={logo} alt={`Logo ${title}`} />
                <p class="mdn-Shortcut-text-description">{description}</p>
              </a>
            </>
          )
        )}
      </div>
    </Wrapper>
  );
}
